export default {
  'top-left': [0, 0],
  top: [0.5, 0],
  'top-right': [1, 0],
  left: [0, 0.5],
  center: [0.5, 0.5],
  right: [1, 0.5],
  'bottom-left': [0, 1],
  bottom: [0.5, 1],
  'bottom-right': [1, 1],
};



// WEBPACK FOOTER //
// /Users/jamess/webdev/react-projects/materialish/docs/src/vendor/react-over/compute-position/coordinates-map.js